import Vue from "vue";
import Router from "vue-router";
import { NotFoundPage } from "./components/pages/NotFoundPage";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/account/",
      component: {
        render: (c) => c("router-view"),
      },
      children: [
        {
          path: "orders/",
          name: "orders-history",
          component: () =>
            import(
              /* webpackChunkName: "OrdersPage" */
              /* eslint-disable-next-line comma-dangle */
              "./components/pages/Account/Orders/index"
            ).then((modules) => modules.OrdersPage),
        },
        {
          path: "prices/",
          name: "prices",
          component: () =>
            import(
              /* webpackChunkName: "PricesPage" */
              /* eslint-disable-next-line comma-dangle */
              "./components/pages/Account/Prices/index"
            ).then((modules) => modules.PricesPage),
        },
        {
          path: "",
          name: "account",
          component: () =>
            import(
              /* webpackChunkName: "AccountPage" */
              /* eslint-disable-next-line comma-dangle */
              "./components/pages/Account"
            ).then((modules) => modules.AccountPage),
        },
      ],
    },
    {
      path: "/catalog/",
      name: "catalog-root",
      component: () =>
        import(
          /* webpackChunkName: "CatalogPage" */
          /* eslint-disable-next-line comma-dangle */
          "./components/pages/CatalogPage"
        ).then((modules) => modules.CatalogPage),
      children: [
        {
          path: "",
          name: "catalog",
        },
        {
          path: "*",
          name: "catalog-detail",
        },
      ],
    },
    {
      path: "/complaints/",
      name: "complaints-root",
      component: () =>
        import(
          /* webpackChunkName: "CatalogPage" */
          /* eslint-disable-next-line comma-dangle */
          "./components/pages/ComplaintsPage"
        ).then((modules) => modules.ComplaintsPage),
      children: [
        {
          path: "",
          name: "complaints",
        },
        {
          path: "*",
          name: "complaints-detail",
        },
      ],
    },
    {
      path: "/digital-catalog/",
      name: "digital-catalog-root",
      component: () =>
        import(
          /* webpackChunkName: "CatalogPage" */
          /* eslint-disable-next-line comma-dangle */
          "./components/pages/ComplaintsPage"
        ).then((modules) => modules.ComplaintsPage),
      children: [
        {
          path: "",
          name: "digital-catalog",
        },
        {
          path: "*",
          name: "digital-catalog-detail",
        },
      ],
    },
    {
      path: "/promo/",
      name: "promo-root",
      component: () =>
        import(
          /* webpackChunkName: "CatalogPage" */
          /* eslint-disable-next-line comma-dangle */
          "./components/pages/CatalogPage"
        ).then((modules) => modules.CatalogPage),
      children: [
        {
          path: "",
          name: "promo",
        },
        {
          path: "*",
          name: "promo-detail",
        },
      ],
    },
    {
      path: "/top/",
      name: "top-root",
      component: () =>
        import(
          /* webpackChunkName: "CatalogPage" */
          /* eslint-disable-next-line comma-dangle */
          "./components/pages/CatalogPage"
        ).then((modules) => modules.CatalogPage),
      children: [
        {
          path: "",
          name: "top",
        },
        {
          path: "*",
          name: "top-detail",
        },
      ],
    },
    {
      path: "/sale/",
      name: "sale-root",
      component: () =>
        import(
          /* webpackChunkName: "CatalogPage" */
          /* eslint-disable-next-line comma-dangle */
          "./components/pages/CatalogPage"
        ).then((modules) => modules.CatalogPage),
      children: [
        {
          path: "new/",
          name: "sale-new-root",
          children: [
            {
              path: "/",
              name: "sale-new",
            },
            {
              path: "*",
              name: "sale-new-detail",
            },
          ],
        },
        {
          path: "",
          name: "sale",
        },
        {
          path: "*",
          name: "sale-detail",
        },
      ],
    },
    {
      path: "/product/:id/",
      name: "product",
      component: () =>
        import(
          /* webpackChunkName: "ProductPage" */
          /* eslint-disable-next-line comma-dangle */
          "./components/pages/ProductPage"
        ).then((modules) => modules.ProductPage),
    },
    {
      path: "/contacts/",
      name: "contacts",
      component: () =>
        import(
          /* webpackChunkName: "ContactsPage" */
          /* eslint-disable-next-line comma-dangle */
          "./components/pages/ContactsPage"
        ).then((modules) => modules.ContactsPage),
    },
    {
      path: "/",
      name: "home",
      component: () =>
        import(
          /* webpackChunkName: "IndexPage" */
          /* eslint-disable-next-line comma-dangle */
          "./components/pages/IndexPage"
        ).then((modules) => modules.IndexPage),
    },
    {
      path: "/cart/",
      name: "shopping-cart",
      component: () =>
        import(
          /* webpackChunkName: "ShoppingCartPage" */
          /* eslint-disable-next-line comma-dangle */
          "./components/pages/ShoppingCartPage"
        ).then((modules) => modules.ShoppingCartPage),
    },
    {
      path: "/auth/set-password/:token",
      name: "password-setting",
      component: () =>
        import(
          /* webpackChunkName: "ShoppingCartPage" */
          /* eslint-disable-next-line comma-dangle */
          "./components/pages/ResetPassPage"
        ).then((modules) => modules.ResetPassPage),
    },
    {
      path: "*",
      name: "404",
      component: NotFoundPage,
    },
  ],
});
router.beforeEach((to, from, next) => {
  try {
    (window as any).simulatedHistory = {
      from,
      to,
    };
  } catch (err) {
    console.warn(err);
  }
  next();
});

export default router;
